import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import text from '../constants/Closet'
import '../styles/components/EmptyCloset.css'

const EmptyCloset = ({ language, onLinkClick }) => {
  return (
    <div className='empty-closet-container'>
      <div className='empty-closet-request-service'>
        {text.notConfig[language]}<br /><br />
        <span className='empty-closet-link' onClick={onLinkClick}>{text.notConfSendLink[language]}</span>
        <span>{text.notConfSendMessage[language]} <FaWhatsapp className='empty-closet-whatsapp' /></span>
      </div>
    </div>
  )
}

export default EmptyCloset



// WEBPACK FOOTER //
// ./src/components/EmptyCloset.js